import React from "react"

export function PageColumns({ children, modifiers }) {
  return (
    <div className={modifiers ? `page-columns ${modifiers}` : `page-columns`}>
      {children}
    </div>
  )
}

export function Column({ children, type, classes }) {
  return type === "media" ? (
    <div
      className={
        classes
          ? `page-columns__column page-columns__column--${type} ${classes}`
          : `page-columns__column page-columns__column--${type}`
      }
    >
      <div className="container md:container--large">{children}</div>
    </div>
  ) : (
    <div
      className={`page-columns__column page-columns__column--${type} text-block`}
    >
      <div className="container md:container--large lg:container--medium">
        {children}
      </div>
    </div>
  )
}
